import type { AbVariant } from '@snapchat/mw-contentful-schema';

// Same code as used in contentful-app package for AbExperimentEntryEditor utils
// but modified to work with MWP data structure
export const getLeftoverPopulation = (variantEntries: AbVariant[]): number => {
  const variantPopulations = variantEntries.map(entry => {
    return (entry.trafficEndRange ?? 0) - (entry.trafficStartRange ?? 0);
  });
  const totalPopulation = variantPopulations.reduce((acc, population) => acc + population, 0);
  const leftoverPopulation = 100 - totalPopulation;

  return leftoverPopulation;
};

// Exact all utm parameters from the url
// Example: https://forbusiness.snapchat.com/advertising/start-snapchat-ads?_sid=PAID&utm_source=GoogleSEM&utm_medium=PAIDB2B&utm_campaign=US_G_Search_Brand_MKAG-snapchatbusiness&utm_term=US&utm_content=startsnapchatads&gad_source=1&gad_campaignid=17476413091&gbraid=0AAAAADJr79hgZXZoOxb0sxoJcKqAImxfC&gclid=CjwKCAiAlfvIBhA6EiwAcErpyXyxlGr_BKaXJMa3O6O8nxURYkWdQMG30tQs7dtZoIBMXvWz5TCnIxoCjjIQAvD_BwE
// => {utm_source: 'GoogleSEM', utm_medium: 'PAIDB2B', utm_campaign: 'US_G_Search_Brand_MKAG-snapchatbusiness', utm_term: 'US', utm_content: 'startsnapchatads'}
export const extractUtmParameters = (url: string): Record<string, string> => {
  const urlObj = new URL(url);
  const utmParameters: Record<string, string> = {};

  for (const [key, value] of urlObj.searchParams.entries()) {
    if (key.startsWith('utm_')) {
      utmParameters[key] = value;
    }
  }

  return utmParameters;
};
